import classNames from 'classnames'
import React from 'react'
import cssStyles from './Progress.module.scss'

interface ProgressProps {
  className?: string
  value: number
  size?: number
  activeColor?: string
  backgroundColor?: string
}

const Progress: React.FC<ProgressProps> = ({
  className,
  value,
  size,
  activeColor,
  backgroundColor,
  children,
}) => {
  const styles = {
    '--progress-active-color': activeColor,
    '--progress-background-color': backgroundColor,
    '--progress-size': `${size || 34}px`,
    '--progress-value': `${value}%`,
  } as React.CSSProperties

  return (
    <div style={styles} className={classNames(className, cssStyles.progress)}>
      <div className={cssStyles.progressActive} />
      <div className={cssStyles.progressInner}>{children}</div>
    </div>
  )
}

export default Progress
